"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doc = void 0;
var react_1 = __importDefault(require("react"));
var Doc = function (_a) {
    var children = _a.children, title = _a.title;
    return (react_1.default.createElement("div", { className: "fill" },
        react_1.default.createElement("p", { className: "f7 fw7" }, title),
        react_1.default.createElement("hr", { className: "bg-light6 mt0 mb4" }),
        children));
};
exports.Doc = Doc;
